
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import { capitalize } from 'utils'

const getOptionValue = (option) => {
  if (option && typeof option === 'object' && 'value' in option) {
    return option.value
  }

  return option
}

const getOptionLabel = (option) => {
  if (option && typeof option === 'object' && 'label' in option) {
    return option.label
  }

  return option
}

const MuiFormSelect = (props) => {
  const options = props?.includeEmptyOption
    ? [{ label: props?.emptyOptionLabel || 'None', value: '' }, ...(props?.options || [])]
    : props?.options

  return (
    <FormControl
      variant="filled"
      sx={{
        '& label': {
          fontSize: 12,
          color: props?.error ? '#EB0A1E' : props?.disabled ? 'rgba(0, 0, 0, 0.38)' : '#00B6B0',
          top: '3px',
          '&.mui-jss-Mui-disabled': {
            color: '#00B6B0',
          }
        },
        '& .mui-jss-MuiInputBase-root': {
          overflow: 'hidden',
          borderRadius: '5px',
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: '#98B6BE',
          '&.mui-jss-Mui-disabled': {
            background: '#F3F5F8'
          }
        },
        '& .mui-jss-MuiSelect-select': {
          paddingTop: '20px',
        },
        '& .mui-jss-MuiInputBase-root:after': {
          content: 'none',
        },
        '& .mui-jss-MuiInputBase-root:before': {
          content: 'none',
        },
        '& .mui-jss-Mui-error': {
          borderColor: '#EB0A1E',
        }
      }}>
      <InputLabel id={props.labelId}>{props.label}</InputLabel>
      <Select
        {...props}
        labelId={props.labelId}
        inputProps={{
          style: {
            fontSize: 12,
            color: '#00B6B0',
            top: 0,
            '&.mui-jss-Mui-disabled': {
              color: '#00B6B0',
            }
          }
        }}>
        {options?.map((option) => (
          <MenuItem
            value={getOptionValue(option)}
            fontSize={14}
            key={`option-${String(getOptionValue(option)).toLowerCase()}`}>
            {capitalize(getOptionLabel(option))}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default MuiFormSelect
